import type { HealthResponse } from '../shared/types.ts';

export type AnalysisAvailability = 'checking' | 'ready' | 'warming' | 'offline';

export function analysisAvailability(health: HealthResponse | null): AnalysisAvailability {
  if (health === null) return 'checking';
  if (health.katago === 'ready') return 'ready';
  if (health.katago === 'starting') return 'warming';
  return 'offline';
}
